export interface IAppConfiguration {
    baseHref: string;
    guideUrl: string;
    oscatUrl: string;
    idpLogoutUrl: string;
    redirectAfterLogout: string;
  }

/**
 * Application configuration model
 */
 export class AppConfiguration implements IAppConfiguration {

    baseHref: string;
    guideUrl: string;
    oscatUrl: string;
    idpLogoutUrl: string;
    redirectAfterLogout: string;
  
    constructor(baseConfig: IAppConfiguration) {
      this.baseHref = baseConfig.baseHref || '/';
      this.guideUrl = baseConfig.guideUrl || '#';
      this.oscatUrl = baseConfig.oscatUrl || '#';
      this.idpLogoutUrl = baseConfig.idpLogoutUrl || '';
      this.redirectAfterLogout = baseConfig.redirectAfterLogout || '';
    }
  }
  